import {
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import AlertMUI from '@material-ui/lab/Alert';
import Alert from 'components/Alert';
import CustomMaskedInput from 'components/MaskedInput';
import ModalActions from 'components/ModalActions';
import { theme } from 'components/Theme';
import { agent, functions } from 'helpers';
import { PF_TRANSFER_LIMIT, FINANCIAL_BLOCK_TOOLTIP_MESSAGE, MIN_TRANSFER_INTERNATIONAL, MIN_TRANSFER } from 'helpers/constants';
import { HotjarEvents, submitEvent } from 'hotjar';
import { EAnticipationStatus } from 'interfaces/IUser';
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { API_MYEDUZZ } from 'settings';
import { bankTransfer, listInvoicesAnticipation, listTransfers } from 'store/Orbita/Financial/actions';
import { listAccounts } from 'store/Orbita/Profile/actions';
import { user } from 'store/Orbita/User/actions';
import WithBetaModules from 'v2/components/Shared/WithBetaModules';
import { numberToBRL } from 'v2/helpers/money';
import { npsService } from 'v2/services/nps';

import AccountList from './components/AccountList';
import styles from './styles';
import TransactionRow from './TransactionRow';

import type IAnticipation from 'interfaces/IAnticipation';
import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';

const TRANSFER_FEEDBACK_SURVEY_ID = 796843;
const TRANSFER_FEEDBACK_SURVEY_EXPIRATION_IN_DAYS = 90;

interface IProps extends DispatchProp<any> {
  currency?: any;
  classes?: any;
  listAccounts: any;
  loadAvailable: any;
  authUser: IUser;
  bankTransfer: any;
  open: boolean;
  onCloseModalTransfer: any;
  listAnticipations: Array<IAnticipation>;
  anticipationsIsFetching: boolean;
  updateCustomerById: any;
  listTransfers: any;
  successCallback?: Function;
  anticipationTransferIsFetching: any;
  selfClose: Function;
  transferByInvoice: boolean;
  newAntecipationTransfer: boolean;
  originalUser: IUser;
  anticipableAvailable: number;
}

interface IState {
  checkedAllAnticipation: boolean;
  valueAccount: any;
  valueTransfer: any;
  invoiceTable: boolean;
  availableValue: any;
  anticipationValue: any;
  arrayInvoicesAnticipation: IAnticipation[];
  daysAnticipation: number;
  selectedAnticipationValues: number;
  openModalDays: boolean;
  modalTransfers: boolean;
  daysAnticipationSelect: number;
  changeAccountList: boolean;
  accountActive: any;
  hasSelectAnticipation: boolean;
  showAccount: boolean;
  isLoadingTransfer: boolean;
  isLoadingAnticipation: boolean;
  isLoadingAnticipationInvoices: boolean;
  isLoadingTransferByInvoice: boolean;
  anticipationAccessStatus: string;
}

class Transaction extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      valueAccount: 0,
      valueTransfer: 0,
      openModalDays: false,
      modalTransfers: false,
      checkedAllAnticipation: false,
      invoiceTable: false,
      availableValue: 0,
      anticipationValue: 0,
      arrayInvoicesAnticipation: [],
      daysAnticipation: 0,
      daysAnticipationSelect: 0,
      selectedAnticipationValues: 0,
      changeAccountList: false,
      accountActive: {},
      hasSelectAnticipation: false,
      showAccount: false,
      isLoadingTransfer: true,
      isLoadingAnticipation: true,
      isLoadingAnticipationInvoices: true,
      isLoadingTransferByInvoice: false,
      anticipationAccessStatus: 'blocked',
    };
  }

  // ao clicar para transferir
  handleClickTransfers = (value: number) => {
    let { arrayInvoicesAnticipation } = this.state;

    const minToTransfer = this.props.authUser?.international_account ? MIN_TRANSFER_INTERNATIONAL : MIN_TRANSFER;
    let valueTransfer = value;
    let valueAvailable = this.props.loadAvailable.value;
    let account = this.props.listAccounts.length ? this.state.accountActive.id : null;

    const commissionsSelected = arrayInvoicesAnticipation.flatMap((invoice) => invoice.commissions.filter((commission) => commission.selected));
    const arrayIds = commissionsSelected.map((commission) => commission.id);
    const totalAnticipation = commissionsSelected.map((commission) => commission.gain).reduce((accumulator, item) => accumulator + item, 0);

    this.setState({ modalTransfers: false });

    let status = {
      success: true,
    };

    if (!account) {
      status.success = false;
      toast.error('Por favor cadastre uma conta bancária.');
    }

    if (this.getActualAmountToTransfer() <= 0) {
      status.success = false;
      toast.error('Por favor digite um valor válido para a transferência.');
    }

    if (valueAvailable > 0 && valueTransfer > valueAvailable) {
      status.success = false;
      toast.error('O valor da transferência é maior que o saldo disponível.');
    }

    if (totalAnticipation < 0) {
      status.success = false;
      toast.error('Por favor digite um valor válido para a antecipação.');
    }

    if (Math.trunc(totalAnticipation * 100) / 100 > Math.trunc(this.props.loadAvailable.available_antecipation * 100) / 100) {
      status.success = false;
      toast.error('O valor da antecipação é maior que o saldo disponível.');
    }

    if (valueAvailable > 0 && valueTransfer < valueAvailable && totalAnticipation > 0) {
      status.success = false;
      toast.error('Por favor utilize 100% do valor de transferencia para solicitar antecipação!');
    }

    if (this.getActualAmountToTransfer() < minToTransfer) {
      status.success = false;
      toast.error(`O valor da transferência é menor que R$ ${minToTransfer}.`);
    }

    if (status.success) {
      (async () => {
        try {
          if (this.getActualAmountToTransfer() > 0) {
            await this.props.dispatch(bankTransfer(this.getActualAmountToTransfer(), account, arrayIds));
          }
          this.props.selfClose();
          if (this.props.successCallback) {
            await this.props.successCallback(true);
          }
          toast.success('Sucesso, transferência enviada para processamento com êxito!');
          await this.props.dispatch(user());
          if (this.props.successCallback) {
            await this.props.successCallback(false);
          }
          const lastAnswer = await npsService.getSurveyLastAnswer(TRANSFER_FEEDBACK_SURVEY_ID);
          if (lastAnswer) {
            const isSurveyExpired = lastAnswer.answered && lastAnswer.days_count >= TRANSFER_FEEDBACK_SURVEY_EXPIRATION_IN_DAYS;
            const shouldShowSurvey = !lastAnswer.answered || isSurveyExpired;
            if (shouldShowSurvey) {
              submitEvent(HotjarEvents.TRANSFER_REQUEST_MADE);
            }
          }
        } catch (err) {
          toast.error(err);
        }
      })();
    }
  };

  onOpenModalTransfers = async (value: number) => {
    const { transferByInvoice, loadAvailable } = this.props;
    const { availableValue, accountActive } = this.state;
    const amount = Number(functions.clearMoneyMask(availableValue));
    let transf: any = null;

    if (transferByInvoice) {
      if (amount > loadAvailable.value) {
        toast.warn('Ops, Valor solicitado para transferência é maior que o disponível');
        return;
      }
      try {
        this.setState({ isLoadingTransferByInvoice: true });
        const minToTransfer = this.props.authUser?.international_account ? MIN_TRANSFER_INTERNATIONAL : MIN_TRANSFER;
        const data: any = await agent.post(`${API_MYEDUZZ}/transfers/check_amount_invoices`, { amount });
        transf = data.data.data;
        if (transf.approx_amount < minToTransfer) {
          await Alert.show({
            message: `O valor mínimo para saque em nossa plataforma é de ${numberToBRL(
              minToTransfer
            )} e a soma de faturas com valor mais próximo ao solicitado é de ${
              transf.approx_amount
            }. Tente novamente com um valor acima disso e dará tudo certo ;)`,
            title: 'Ops, foi por pouco',
            confirmation: false,
          });
          this.setState({ isLoadingTransferByInvoice: false });
          return;
        }
        const confirm = await Alert.show({
          message: `A soma de faturas com valor mais próximo ao solicitado é de ${transf.approx_amount}. Deseja continuar com a transferência?`,
          title: 'Valor à Transferir',
          confirmation: true,
        });
        if (!confirm) {
          this.setState({ isLoadingTransferByInvoice: false });
          return;
        }
      } catch (error) {
        this.setState({ isLoadingTransferByInvoice: false });
        toast.error(error.data.message);
      }

      try {
        if (transf) {
          await agent.post(`${API_MYEDUZZ}/transfers/amount_invoices`, {
            transfer_key: transf.transfer_key,
            transfer_method_id: accountActive.id,
          });
          this.setState({ isLoadingTransferByInvoice: false });
          toast.success('Sucesso, transferência enviada para processamento com êxito!');
          this.props.selfClose();
          await this.props.dispatch(user());
          if (this.props.successCallback) {
            await this.props.successCallback(false);
          }
        }
      } catch (error) {
        toast.error(error.data.message);
        this.setState({ isLoadingTransferByInvoice: false });
      }
    } else {
      this.setState({ modalTransfers: true, valueTransfer: value });
    }
  };

  onCancelModalTransfers = () => {
    this.setState({ modalTransfers: false });
  };

  onCancelModal = () => {
    this.setState({ openModalDays: false });
  };

  onOpenModal = (value: number) => () => {
    this.setState({ openModalDays: true, daysAnticipationSelect: value });
  };

  handleChangeTransferInput = (value: string | number) => {
    this.setState({
      availableValue: value,
      valueTransfer: value,
    });
  };

  // expandir invoices
  handleClickExpandedInvoices = () => {
    this.setState({
      invoiceTable: !this.state.invoiceTable,
    });
  };

  hasItemToSelect = () => {
    let { arrayInvoicesAnticipation, selectedAnticipationValues } = this.state;
    let { loadAvailable } = this.props;
    let has = false;

    if (arrayInvoicesAnticipation && arrayInvoicesAnticipation.length) {
      let items = arrayInvoicesAnticipation.filter((item: any) => {
        return item.selected === false;
      });

      for (let i = 0; i < items.length; i++) {
        if (
          loadAvailable.available_antecipation > selectedAnticipationValues &&
          loadAvailable.available_antecipation > selectedAnticipationValues + items[i].gain
        ) {
          has = true;
        }
      }
    }
    return has;
  };

  getNewAnticipationSelectedValue = (newInvoices: IAnticipation[]) => {
    const allCommissionsSelected = newInvoices.flatMap((invoice) => invoice.commissions.filter((commission) => commission.selected));
    const allSelectedGains = allCommissionsSelected.map((commission) => commission.gain);
    const newSelectedAnticipationValues = allSelectedGains.reduce((currentGain, total) => currentGain + total, 0);

    return newSelectedAnticipationValues;
  };

  // selecionar o checkbox da fatura
  handleChangeSelectCommission = (item: IAnticipation, selectedCommision: number) => {
    let { arrayInvoicesAnticipation } = this.state;

    // Change commission select
    const currentInvoice = item;
    const currentCommission = currentInvoice.commissions.find((commission) => commission.id === selectedCommision);
    const isSelected = !currentCommission.selected;

    if (!currentCommission.isSelectable) return;

    currentInvoice.commissions.find((commission) => commission.id === selectedCommision).selected = isSelected;
    currentInvoice.commissions.forEach((commission) => isSelected && !commission.isSelectable && (commission.selected = isSelected));

    const commissionsSelected = currentInvoice.commissions.filter((commission) => commission.selected).length;

    currentInvoice.selected = commissionsSelected === currentInvoice.commissions.length;

    const newInvoices = arrayInvoicesAnticipation.map((invoice: IAnticipation) => {
      if (invoice.id === currentInvoice.id) {
        invoice = currentInvoice;
      }

      return invoice;
    });

    // Verify if any commission is missing check
    const hasCommissionsUnchecked = !!newInvoices.filter((invoice) => invoice.commissions.filter((commission) => !commission.selected).length).length;

    return this.setState({
      selectedAnticipationValues: this.getNewAnticipationSelectedValue(newInvoices),
      arrayInvoicesAnticipation: newInvoices,
      checkedAllAnticipation: !hasCommissionsUnchecked,
    });
  };

  handleChangeSelectInvoice = (item: IAnticipation) => {
    let { arrayInvoicesAnticipation } = this.state;

    const currentInvoice = item;
    const isSelected = !currentInvoice.selected;

    currentInvoice.selected = isSelected;
    currentInvoice.commissions.forEach((commission) => (commission.selected = isSelected));

    const newInvoices = arrayInvoicesAnticipation.map((invoice: IAnticipation) => {
      if (invoice.id === currentInvoice.id) {
        invoice = currentInvoice;
      }

      return invoice;
    });

    // Verify if any commission is missing check
    const hasCommissionsUnchecked = !!newInvoices.filter((invoice) => invoice.commissions.filter((commission) => !commission.selected).length).length;

    return this.setState({
      selectedAnticipationValues: this.getNewAnticipationSelectedValue(newInvoices),
      arrayInvoicesAnticipation: newInvoices,
      checkedAllAnticipation: !hasCommissionsUnchecked,
    });
  };

  handleChangeSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { arrayInvoicesAnticipation } = this.state;

    event.stopPropagation();

    arrayInvoicesAnticipation.forEach((invoice) => {
      invoice.commissions.forEach((commission) => (commission.selected = event.target.checked));
      invoice.selected = event.target.checked;
    });

    this.setState({
      arrayInvoicesAnticipation,
      selectedAnticipationValues: this.getNewAnticipationSelectedValue(arrayInvoicesAnticipation),
      checkedAllAnticipation: event.target.checked,
    });
  };

  loadAnticipationInvoices = async () => {
    try {
      await this.props.dispatch(listInvoicesAnticipation());

      const arrayInvoicesAnticipation: Array<IAnticipation> = this.props.listAnticipations;

      this.setState({
        arrayInvoicesAnticipation,
        selectedAnticipationValues: this.getNewAnticipationSelectedValue(arrayInvoicesAnticipation),
        isLoadingAnticipationInvoices: false,
      });
    } catch (error) {
      toast.error('Ops, erro na listagem de faturas');
    }
  };

  async componentDidMount() {
    try {
      await this.props.dispatch(listTransfers());
      this.setState({ isLoadingTransfer: false });
    } catch (error) {
      toast.error('Ops, erro ao verificar as transferências.');
    }

    const dispatchListAccountsPromise = this.props.dispatch(listAccounts('active'));
    const loadAnticipationInvoicesPromise = this.loadAnticipationInvoices();
    const featureAccessPromise = agent.get(`${API_MYEDUZZ}/customers/feature-access`);

    const [featureAccessResult] = await Promise.all([featureAccessPromise, dispatchListAccountsPromise, loadAnticipationInvoicesPromise]);

    const anticipationAccessStatus = featureAccessResult.data.data.anticipation.status;

    const getAccount = () => {
      if (!this.props?.listAccounts?.length) {
        return null;
      }

      const findAccount = this.props?.listAccounts?.find((item: any) => item.main);

      if (!findAccount) {
        return this.props.listAccounts[0];
      }

      return findAccount;
    };

    this.setState({
      accountActive: getAccount(),
      hasSelectAnticipation: this.hasItemToSelect(),
      showAccount: false,
      isLoadingAnticipation: false,
      anticipationAccessStatus,
    });
  }

  handleChangeAccount = (account: any) => {
    this.setState({
      accountActive: account,
    });

    this.toggleChangeAccount();
  };

  toggleChangeAccount = () => {
    this.setState({
      changeAccountList: !this.state.changeAccountList,
    });
  };

  showBankAccount = (status: boolean) => {
    this.setState({
      showAccount: status,
    });
  };

  parseFieldToFloat = (fieldValue: string | number) => {
    return Number.parseFloat(functions.clearMoneyMask(fieldValue));
  };

  hasSelectedAnticipation = () => this.state.selectedAnticipationValues > 0;

  getActualAmountToTransferWithoutNegative = (): number => {
    const { selectedAnticipationValues, valueTransfer } = this.state;

    if (!this.hasSelectedAnticipation() && this.hasAvailableValue()) {
      return this.parseFieldToFloat(valueTransfer);
    }

    return selectedAnticipationValues + this.parseFieldToFloat(valueTransfer);
  };

  getActualAmountToTransfer = (): number => {
    const { loadAvailable } = this.props;

    if (loadAvailable.value >= 0) {
      return this.getActualAmountToTransferWithoutNegative();
    }
    const value = loadAvailable.value > 0 ? this.parseFieldToFloat(loadAvailable.value) : loadAvailable.value;
    return this.getActualAmountToTransferWithoutNegative() + value;
  };

  hasAvailableValue = () => !this.props.loadAvailable.isFetching && this.props.loadAvailable.value > 0;

  isInvoiceSelected = (invoice: IAnticipation) => {
    const alreadyTransfered = this.props.listTransfers.already_transfered;
    const limitPF = PF_TRANSFER_LIMIT - alreadyTransfered;

    if (this.props.authUser.type === 'F' && this.state.selectedAnticipationValues + invoice.gain > limitPF) {
      return true;
    }

    return !invoice.selected && this.props.loadAvailable.available_antecipation < this.state.selectedAnticipationValues + invoice.gain;
  };

  canAnticipate = (arrayInvoicesAnticipation: any, valueAvailableToAnticipate: number, transferValue: number) => {
    const alreadyTransfered = this.props.listTransfers.already_transfered;

    if (this.props.originalUser?.anticipation_status === EAnticipationStatus.BLOQUEADO) {
      return {
        anticipationUnavailableMessage: 'Antecipação bloqueada por alto índice de chargeback',
        canAnticipate: false,
      };
    }

    if (this.state.anticipationAccessStatus === 'blocked') {
      return {
        anticipationUnavailableMessage:
          'Ainda não é possível antecipar suas vendas. Para utilizar essa funcionalidade, aguarde o prazo de 30 dias a partir da data de pagamento da sua primeira venda.',
        canAnticipate: false,
      };
    }

    if (this.props.authUser.type === 'F' && alreadyTransfered >= PF_TRANSFER_LIMIT) {
      return {
        anticipationUnavailableMessage: 'A antecipação irá ultrapassar o limite disponível para transferência (R$1.900,00)',
        canAnticipate: false,
      };
    }

    if (Array.isArray(arrayInvoicesAnticipation) && arrayInvoicesAnticipation.length <= 0) {
      return {
        anticipationUnavailableMessage: 'Você não possui faturas para antecipar',
        canAnticipate: false,
      };
    }

    if (transferValue > valueAvailableToAnticipate) {
      return {
        anticipationUnavailableMessage: 'Valor indisponível',
        canAnticipate: false,
      };
    }

    if (valueAvailableToAnticipate === 0) {
      return {
        anticipationUnavailableMessage: 'Você não possui saldo para antecipar',
        canAnticipate: false,
      };
    }

    if (this.props.transferByInvoice || !this.props.newAntecipationTransfer) {
      return {
        anticipationUnavailableMessage: 'Antecipação indisponível',
        canAnticipate: false,
      };
    }

    return {
      anticipationUnavailableMessage: '',
      canAnticipate: true,
    };
  };

  render() {
    const { classes, listAnticipations, anticipationsIsFetching, updateCustomerById, newAntecipationTransfer, authUser } = this.props;
    const {
      arrayInvoicesAnticipation,
      checkedAllAnticipation,
      isLoadingTransferByInvoice,
      isLoadingTransfer,
      isLoadingAnticipation,
      isLoadingAnticipationInvoices,
    } = this.state;
    const listAccounts = this.props.listAccounts;
    const minToTransfer = authUser?.international_account ? MIN_TRANSFER_INTERNATIONAL : MIN_TRANSFER;

    const hasSomeCommissionChecked = !!arrayInvoicesAnticipation.filter(
      (invoice) => invoice.commissions.filter((commission) => commission.selected).length
    ).length;

    const { canAnticipate, anticipationUnavailableMessage } = this.canAnticipate(
      arrayInvoicesAnticipation,
      Number.parseFloat(functions.clearMoneyMask(this.props.loadAvailable.available_antecipation)),
      Number.parseFloat(functions.clearMoneyMask(this.state.selectedAnticipationValues))
    );

    const cantTransfer = (() => {
      const { bankTransfer, anticipationTransferIsFetching } = this.props;
      if (bankTransfer && bankTransfer.isFetching) {
        return true;
      }

      if (anticipationTransferIsFetching) {
        return true;
      }

      const hasAnticipation = Number.parseFloat(this.state.selectedAnticipationValues.toString()) > 0;
      const hasTransfer = Number.parseFloat(functions.clearMoneyMask(this.state.valueTransfer)) > 0;
      const transferValue = Number.parseFloat(functions.clearMoneyMask(this.state.valueTransfer));
      const transferAvailable = this.props.loadAvailable ? this.props.loadAvailable.value : 0;
      const availableValueFloat = Number.parseFloat(functions.clearMoneyMask(this.state.availableValue));

      if (availableValueFloat < transferAvailable && hasAnticipation) {
        return true;
      }

      if (this.getActualAmountToTransfer() < minToTransfer) {
        return true;
      }

      if (hasAnticipation && hasTransfer && transferValue !== transferAvailable) {
        return true;
      }

      if (!hasAnticipation && hasTransfer && this.getActualAmountToTransfer() > Number.parseFloat(functions.clearMoneyMask(transferAvailable))) {
        return true;
      }

      return false;
    })();

    const renderTooltipValue = (() => {
      const availableValueFloat = Number.parseFloat(functions.clearMoneyMask(this.state.availableValue));

      if (availableValueFloat < this.props.loadAvailable.value && checkedAllAnticipation) {
        return <p>Use todo o seu saldo disponível antes de antecipar</p>;
      }

      if (this.getActualAmountToTransfer() < minToTransfer) {
        return (
          <p>
            Valor mínimo para transferir: <FormattedNumber value={minToTransfer} format={'BRL'}></FormattedNumber>
          </p>
        );
      }

      return '';
    })();

    return (
      <>
        <MuiThemeProvider theme={theme}>
          <Modal
            open={this.props.open}
            onClose={this.props.onCloseModalTransfer}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                maxHeight: '90vh',
                overflow: 'auto',
                borderRadius: 4,
              }}
              className={classes.paper + (this.state.changeAccountList ? ' modal__transaction --flip' : ' modal__transaction')}
            >
              <div
                onClick={this.props.onCloseModalTransfer}
                className='transaction__exit'
                style={{ position: 'absolute', right: '24px', top: '24px', cursor: 'pointer' }}
              >
                <Icon>close</Icon>
              </div>
              {!this.state.changeAccountList && (
                <>
                  <Grid container spacing={0} className='transacation-list__accounts'>
                    <Grid item>
                      <div className='my-title' style={{ paddingRight: 8 }}>
                        <h2>Informe o valor que deseja transferir.</h2>
                      </div>
                    </Grid>
                    <div className={classes.contentAmount}>
                      <div className={classes.rowAmount}>
                        <div className={'amount__checkbox'}>
                          <span className='label' style={{ marginRight: 30 }}>
                            Saldo Disponível:
                          </span>
                        </div>
                        <div className={'amount__value'}>
                          {this.props.loadAvailable && (this.props.loadAvailable.value || this.props.loadAvailable.value === 0) ? (
                            <FormattedNumber value={this.props.loadAvailable.value} format='BRL' />
                          ) : (
                            'Carregando...'
                          )}
                        </div>
                        <div className={'amount__input'}>
                          <CustomMaskedInput
                            id='input-available'
                            className={classes.inputAmount}
                            mask='money'
                            onChange={(value: number | string) => this.handleChangeTransferInput(value)}
                            disabled={!this.hasAvailableValue()}
                            margin='normal'
                            style={{ padding: '0 10px', borderRadius: 4, border: '1px solid #eee' }}
                            disableUnderline={true}
                            value={functions.addMoneyMask(this.state.availableValue.toString())}
                          />
                        </div>
                      </div>
                    </div>

                    {!newAntecipationTransfer && (
                      <div className={classes.contentAmount}>
                        <div className={classes.rowAmount}>
                          <span className='label' style={{ margin: '10px 30px' }}>
                            Antecipação de valores de forma manual está desabilitada, se você necessita antecipar algum valor, por favor, abrir um
                            chamado com o <b>título &quot;Antecipação&quot;</b> em
                            <b>suporte@eduzz.com.</b>
                            <br />
                            As antecipações solicitadas serão realizadas às 12h00 e 17h00 de segunda à sexta.
                          </span>
                        </div>
                      </div>
                    )}

                    <div className={classes.contentAmount}>
                      <div className={classes.rowAmount}>
                        {isLoadingTransfer || isLoadingAnticipation || isLoadingAnticipationInvoices ? (
                          <div>
                            <span>Carregando...</span>
                          </div>
                        ) : (
                          <>
                            {canAnticipate && (
                              <>
                                <div className={'amount__checkbox'}>
                                  <Checkbox
                                    checked={checkedAllAnticipation}
                                    onChange={this.handleChangeSelectAll}
                                    value={'anticipation'}
                                    color={'primary'}
                                    className={classes.checkbox}
                                    indeterminate={(hasSomeCommissionChecked && !checkedAllAnticipation) || null}
                                  />
                                  <span className='label' style={{ marginLeft: 10 }}>
                                    Faturas Antecipáveis:
                                  </span>
                                </div>
                                <div className={'amount__value'}>
                                  <span style={{ cursor: 'pointer' }} onClick={this.handleClickExpandedInvoices}>
                                    <FormattedNumber value={this.props.anticipableAvailable} format='BRL' />
                                  </span>
                                  <Icon
                                    onClick={this.handleClickExpandedInvoices}
                                    style={{
                                      position: 'relative',
                                      cursor: 'pointer',
                                      transition: '0.3s',
                                      transform: this.state.invoiceTable ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                  >
                                    keyboard_arrow_down
                                  </Icon>
                                </div>
                                <div className={'amount__input'}>
                                  <CustomMaskedInput
                                    id='input-anticipation'
                                    className={classes.inputAmount}
                                    mask='money'
                                    margin='normal'
                                    disabled
                                    disableUnderline={true}
                                    style={{ padding: '0 10px', borderRadius: 4 }}
                                    value={functions.addMoneyMask(this.state.selectedAnticipationValues.toString())}
                                  />
                                </div>
                              </>
                            )}
                            {!canAnticipate && (
                              <AlertMUI severity='error' style={{ width: '100%' }}>
                                <span className='label' style={{ textAlign: 'center' }}>
                                  {anticipationUnavailableMessage}
                                </span>
                              </AlertMUI>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {this.state.invoiceTable && (
                      <div className={classes.table}>
                        {anticipationsIsFetching && (
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            <CircularProgress size={22} />
                          </div>
                        )}
                        {!anticipationsIsFetching && (
                          <Table>
                            <TableHead style={{ height: 30 }}>
                              <TableRow style={{ height: 30 }}>
                                <TableCell style={{ width: 20, padding: '0 8px' }}>*</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell align='right' style={{ padding: '0 10px 0 0' }}>
                                  Valor líquido
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {listAnticipations &&
                                !!arrayInvoicesAnticipation.length &&
                                arrayInvoicesAnticipation.map((invoice: IAnticipation, index: any) => {
                                  const isNotSelected = !invoice.selected && this.isInvoiceSelected(invoice);

                                  return (
                                    <Tooltip
                                      key={index}
                                      disableFocusListener={!isNotSelected}
                                      disableHoverListener={!isNotSelected}
                                      disableTouchListener={!isNotSelected}
                                      placement={'bottom'}
                                      title={'Não é possível selecionar essa fatura devido o valor á antecipar ser maior que o permitido'}
                                    >
                                      <TransactionRow
                                        invoice={invoice}
                                        isNotSelected={isNotSelected}
                                        handleChangeSelectCommission={this.handleChangeSelectCommission}
                                        handleChangeSelectInvoice={this.handleChangeSelectInvoice}
                                      />
                                    </Tooltip>
                                  );
                                })}
                              {listAnticipations && arrayInvoicesAnticipation.length === 0 && (
                                <TableRow>
                                  <TableCell colSpan={3} style={{ width: '100%', textAlign: 'center', padding: 0 }}>
                                    Nenhuma fatura encontrada...
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        )}
                      </div>
                    )}
                    <div className={classes.transfer}>
                      <div>
                        <h3>Valor a transferir:</h3>
                      </div>
                      <div>
                        <FormattedNumber value={this.getActualAmountToTransfer()} format='BRL' />
                      </div>
                    </div>
                    <div className={classes.bank}>
                      {listAccounts && !listAccounts.isFetching && listAccounts.length > 0 && (
                        <div>
                          Transferir para Banco:
                          {this.state.showAccount ? (
                            <>
                              <span>{this.state.accountActive.bank_id}</span>, Ag:{' '}
                              <span>
                                {this.state.accountActive.agency}-{this.state.accountActive.agency_digit}
                              </span>
                              , Conta:{' '}
                              <span>
                                {this.state.accountActive.account}-{this.state.accountActive.account_digit}
                              </span>
                              <span>, {this.state.accountActive.type}</span>
                              <IconButton onClick={() => this.showBankAccount(false)}>
                                <Icon>visibility_off</Icon>
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <span>{this.state.accountActive.bank_id && this.state.accountActive.bank_id.replace(/[0-9]/g, '*')}</span>, Ag:{' '}
                              <span>
                                {this.state.accountActive.agency && this.state.accountActive.agency.replace(/[0-9]/g, '*')}-
                                {this.state.accountActive.agency_digit && this.state.accountActive.agency_digit.replace(/[0-9]/g, '*')}
                              </span>
                              , Conta:{' '}
                              <span>
                                {this.state.accountActive.account && this.state.accountActive.account.replace(/[0-9]/g, '*')}-
                                {this.state.accountActive.account_digit && this.state.accountActive.account_digit.replace(/[0-9]/g, '*')}
                              </span>
                              .
                              <IconButton onClick={() => this.showBankAccount(true)}>
                                <Icon>visibility</Icon>
                              </IconButton>
                            </>
                          )}
                          <p
                            onClick={this.toggleChangeAccount}
                            style={{
                              cursor: 'pointer',
                              color: '#3f51b5',
                              fontSize: '14px',
                              lineHeight: '14px',
                              marginTop: 5,
                              marginBottom: 0,
                            }}
                          >
                            Clique aqui para alterar a conta
                          </p>
                        </div>
                      )}
                      {listAccounts && listAccounts.isFetching && (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <CircularProgress size={22} />
                        </div>
                      )}
                      {listAccounts && !listAccounts.isFetching && listAccounts.length === 0 && <div>Nenhuma conta bancária está ativa.</div>}
                    </div>
                    <div className='m16'></div>
                    <WithBetaModules>
                      {(betaModules: string[]) => {
                        const userHasBlockTransferBetaModule = betaModules?.includes('block_transfer');
                        const renderTooltipBlockTransfer = userHasBlockTransferBetaModule ? FINANCIAL_BLOCK_TOOLTIP_MESSAGE : false;
                        return (
                          <Tooltip title={renderTooltipBlockTransfer || renderTooltipValue} placement='top'>
                            <div style={{ width: '100%' }}>
                              <Button
                                color='primary'
                                variant='contained'
                                className={classes.button}
                                fullWidth
                                onClick={() =>
                                  this.onOpenModalTransfers(
                                    this.state.availableValue ? Number.parseFloat(functions.clearMoneyMask(this.state.availableValue)) : 0
                                  )
                                }
                                disabled={cantTransfer || isLoadingTransferByInvoice || userHasBlockTransferBetaModule}
                              >
                                Transferir
                                {(this.props.bankTransfer && (this.props.bankTransfer.isFetching || this.props.anticipationTransferIsFetching)) ||
                                  (isLoadingTransferByInvoice && <CircularProgress size={20} style={{ color: '#596375', marginLeft: 10 }} />)}
                              </Button>
                            </div>
                          </Tooltip>
                        );
                      }}
                    </WithBetaModules>
                  </Grid>
                </>
              )}

              {this.state.changeAccountList && (
                <AccountList
                  handleChangeAccount={this.handleChangeAccount}
                  accountDefault={this.state.accountActive}
                  toggleChangeAccount={this.toggleChangeAccount}
                />
              )}
            </div>
          </Modal>
          <ModalActions
            open={this.state.modalTransfers}
            onClose={this.onCancelModalTransfers}
            onOk={() =>
              this.handleClickTransfers(this.state.availableValue ? Number.parseFloat(functions.clearMoneyMask(this.state.availableValue)) : 0)
            }
            title={'Atenção'}
            buttonOk={'Continuar'}
            loading={updateCustomerById && updateCustomerById.isFetching}
            loadingColor='#ccc'
          >
            <p>
              {!this.hasAvailableValue() ? (
                <p>
                  Você solicitou uma transferência com antecipação no valor de{' '}
                  <b>
                    <FormattedNumber value={this.getActualAmountToTransferWithoutNegative()} format='BRL' />
                  </b>
                  , porém o valor disponível para saque atualmente é negativo, portanto, esse valor negativo de <br></br>
                  <b>
                    <FormattedNumber value={this.props.loadAvailable.value} format='BRL' />
                  </b>{' '}
                  será descontado de sua transferência juntamente com os encargos de transferência no valor de <b>R$ 9,00</b>, resultando no valor
                  final de{' '}
                  <b>
                    <FormattedNumber value={this.getActualAmountToTransfer() - 9} format='BRL' />
                  </b>
                  .
                </p>
              ) : (
                <p>
                  Você solicitou uma transferência no valor de{' '}
                  <b>
                    <FormattedNumber value={this.getActualAmountToTransfer()} format='BRL' />
                  </b>
                  .
                  <br />
                  Neste valor, serão descontados os encargos de transferência no valor de R$ 9,00. Então o valor total transferido para sua conta será
                  de{' '}
                  <b>
                    <FormattedNumber value={this.getActualAmountToTransfer() - 9} format='BRL' />
                  </b>
                  .
                </p>
              )}
              <br />
              Deseja continuar com a transação?
            </p>
          </ModalActions>
        </MuiThemeProvider>
      </>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  originalUser: state.orbita.User.originalUser,
  authUser: state.orbita.User.user.user,
  listAccounts: state.orbita.Profile.accounts,
  loadAvailable: state.orbita.Financial.loadAvailable,
  bankTransfer: state.orbita.Financial.bankTransfer,
  listAnticipations: state.orbita.Financial.listInvoicesAnticipation?.invoices || [],
  anticipableAvailable: state.orbita.Financial.listInvoicesAnticipation?.availableAnticipation,
  anticipationsIsFetching: state.orbita.Financial.listInvoicesAnticipation?.isFetching,
  listTransfers: state.orbita.Financial.listTransfers,
  updateCustomerById: state.orbita.Customer.updateCustomer,
  anticipationTransferIsFetching: state.orbita.Financial.listInvoicesAnticipation && state.orbita.Financial.anticipationTransfer.isFetching,
  transferByInvoice: state.orbita.User.user.user.invoice_transfer,
  newAntecipationTransfer: state.orbita.User.user.user.new_anticipation_transfer,
});

export default connect(mapStateToProps)(styles(Transaction));
